import React from "react";
import Slide from "@material-ui/core/Slide";
import dateFormat from "dateformat";
import _ from "lodash";
import store from "@Core/store";
import { INVALIDATE_USER } from "@Types/actionTypes";
import { CDNurl } from "@Configs/globalConfig";

const initialSelectedFilters = { domain: "0", case: "0", media: "0" };
const operatorCountryConfig = require("@Configs/operatorCountryConfig");

export function bytesToSize(bytes) {
  var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "0 Byte";
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 4);
  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
}

export function transitionUp(props) {
  return <Slide direction="up" {...props} />;
}

export function convertObjToArray(obj) {
  var list = [];
  _.forOwn(obj, function (value, key) {
    list.push({ ...value, key: key });
  });
  return list;
}

export function logout() {
  localStorage.removeItem("Token");
  localStorage.removeItem("Id");
  localStorage.removeItem("UserName");
  localStorage.removeItem("Name");
  localStorage.removeItem("FirstName");
  localStorage.removeItem("LastName");
  localStorage.removeItem("Email");
  localStorage.removeItem("CultureID");
  localStorage.removeItem("CustomerID");
  localStorage.removeItem("AvatarID");
  localStorage.removeItem("AvatarImage");
  localStorage.removeItem("IAT");
  localStorage.removeItem("CD");
  localStorage.removeItem("RoleID");
  localStorage.removeItem("posCases");
  localStorage.removeItem("posDomains");
  localStorage.removeItem("posMedia");
  localStorage.removeItem("media_info_config");
  localStorage.removeItem("SelectedFilters");
  localStorage.removeItem("isSearch");
  localStorage.removeItem("ownParty");
}

export function numberToLocaleString(number) {
  if (!number && number !== 0) return;
  let locale = localStorage.getItem("i18nextLng");
  if (!locale) locale = "en-US";
  if (locale === "de") locale = "de-DE";

  return number.toLocaleString(locale, { minimumFractionDigits: 2 });
}

export function generateAvatar(avatarId) {
  if (avatarId) localStorage.setItem("AvatarID", avatarId);
  var image =
    "" +
    CDNurl +
    localStorage.getItem("AvatarID") +
    "?dt=" +
    Date.now() +
    "&t=" +
    localStorage.getItem("Token");
  return image;
}

export function formatDomainName(domainName, maxLength = 32) {
  var shortend = "";
  if (domainName.length >= maxLength) {
    shortend = "..." + domainName.substr(domainName.length - 29);
  } else {
    shortend = domainName;
  }

  return shortend;
}

export function formatDatetime(rawDatetime, fullShort) {
  if (!rawDatetime) return "";
  /**
   * @type {Date}
   */
  let theDate = null;

  if (typeof rawDatetime === "string") theDate = new Date(rawDatetime);
  if (typeof rawDatetime === "object") theDate = rawDatetime;

  let lang = localStorage.getItem("i18nextLng");
  if (lang === "de-DE" || lang === "de") {
    if (fullShort === "short") {
      return theDate.toLocaleTimeString("de-DE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    } else if (fullShort === "medium-short") {
      return theDate.toLocaleTimeString("de-DE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "2-digit",
      });
    } else if (fullShort === "medium") {
      return theDate.toLocaleTimeString("de-DE", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      });
    } else {
      return theDate.toLocaleTimeString("de-DE", {
        year: "numeric",
        month: "long",
        day: "2-digit",
        hour: "numeric",
        weekday: "long",
        second: "2-digit",
        minute: "2-digit",
      });
    }
  } else {
    if (fullShort === "short") {
      return dateFormat(rawDatetime, "d.m.yyyy");
    } else if (fullShort === "medium-short") {
      return dateFormat(rawDatetime, "dd.mm.yyyy, h:MM TT");
    } else if (fullShort === "medium") {
      return dateFormat(rawDatetime, "mmmm dS, yyyy, h:MM TT");
    } else {
      return dateFormat(rawDatetime, "dddd, mmmm dS, yyyy, h:MM:ss TT");
    }
  }
}

export function replaceBrTags(note) {
  if (!note) return;
  var formatted = "";
  formatted = note.replace(/<br \/>/g, "\r\n");
  formatted = formatted.replace(/<br\/>/g, "\r\n");
  return formatted;
}

export function decodeEntities(str) {
  // this prevents any overhead from creating the object each time
  var element = document.createElement("div");

  function decodeHTMLEntities(str) {
    if (str && typeof str === "string") {
      // strip script/html tags
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "");
      element.innerHTML = str;
      str = element.textContent;
      element.textContent = "";
    }

    return str;
  }

  return decodeHTMLEntities(str);
}

export function isEmptyObject(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

export function mapTagsToSelectOption(tags) {
  return convertObjToArray(tags).map((tag) => ({
    value: tag.id,
    label: tag.name,
  }));
}

export function mapSelectOptionToTag(selectOption) {
  return {
    id: selectOption.value,
    name: selectOption.label,
  };
}

export function handleForbiddenError(status) {
  var authReducer = store.getState().authReducer;
  if (authReducer.validated === true && status === 403) {
    store.dispatch({ type: INVALIDATE_USER });
  }
}

export function updatedSelectedFilters(type, filterId) {
  if (localStorage.getItem("SelectedFilters") == null) {
    localStorage.setItem(
      "SelectedFilters",
      JSON.stringify(initialSelectedFilters),
    );
  }

  var selectedFilters = JSON.parse(localStorage.getItem("SelectedFilters"));
  if (
    !_.has(selectedFilters, "domain") ||
    !_.has(selectedFilters, "case") ||
    !_.has(selectedFilters, "media")
  ) {
    selectedFilters = initialSelectedFilters;
  }

  // selectedFilters[store.getState().filterReducer.currentFilterType] = store.getState().filterReducer.currentfilterId;
  selectedFilters[type] = filterId !== 0 ? filterId.toUpperCase() : filterId;
  localStorage.setItem("SelectedFilters", JSON.stringify(selectedFilters));
}

export function getSelectedFilters() {
  if (localStorage.getItem("SelectedFilters") == null) {
    localStorage.setItem(
      "SelectedFilters",
      JSON.stringify(initialSelectedFilters),
    );
  }

  try {
    var selectedFilters = JSON.parse(localStorage.getItem("SelectedFilters"));
  } catch (error) {
    selectedFilters = initialSelectedFilters;
  }

  if (
    !_.has(selectedFilters, "domain") ||
    !_.has(selectedFilters, "case") ||
    !_.has(selectedFilters, "media")
  ) {
    selectedFilters = initialSelectedFilters;
  }

  const filterReducer = store.getState().filterReducer;
  if (filterReducer.filters != null) {
    if (
      selectedFilters["domain"] !== "0" &&
      filterReducer.filters[selectedFilters["domain"]] === undefined &&
      selectedFilters["domain"] !== "CLAIM"
    ) {
      selectedFilters["domain"] = "0";
    }
    if (
      selectedFilters["case"] !== "0" &&
      filterReducer.filters[selectedFilters["case"]] === undefined
    ) {
      selectedFilters["case"] = "0";
    }
    if (
      selectedFilters["media"] !== "0" &&
      filterReducer.filters[selectedFilters["media"]] === undefined
    ) {
      selectedFilters["media"] = "0";
    }
  }

  localStorage.setItem("SelectedFilters", JSON.stringify(selectedFilters));
  return selectedFilters;
}

export function getIndexBy(arr, name, value) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i][name] === value) {
      return i;
    }
  }
  return -1;
}

export function hasFilterEmptyValues(filter) {
  if (filter.name === null || filter.name.trim() === "") {
    return true;
  }
  for (var key in filter.rules) {
    //check filter property and filter operation
    if (
      filter.rules[key].subfilterId === null ||
      filter.rules[key].subfilterId === "" ||
      filter.rules[key].operationId === null ||
      filter.rules[key].operationId === "" ||
      filter.rules[key].operationId === 0 ||
      filter.rules[key].operationId === "0" ||
      filter.rules[key].ruleValue === null
    )
      return true;

    //check filter value
    //depending on filter property different conditions must be met
    if (
      parseInt(filter.rules[key].operationId) !== 66 &&
      parseInt(filter.rules[key].operationId) !== 70
    ) {
      // the operation is not tag -> no-tag and is not special.
      // the value must be set
      if (filter.rules[key].ruleValue === "") return true;
    }

    // check valid value for special filter 2
    if (filter.rules[key].subfilterId === 113) {
      if (/^[a-z]-[a-z]$/.test(filter.rules[key].ruleValue) === false) {
        return true;
      }
    }
  }

  return false;
}

export function hasFilterDuplicateName(filters, newName) {
  var count = 0;
  for (var key in filters) {
    if (filters[key].name === newName) count++;
    if (count >= 2) return true;
  }
  return false;
}

export function isFilterInUse(allFilters, filterId) {
  for (var filtersKey in allFilters) {
    for (var key in allFilters[filtersKey].rules) {
      if (
        allFilters[filtersKey].rules[key].ruleValue === filterId &&
        allFilters[filtersKey].rules[key].operationId === "5"
      )
        return true;
    }
  }
  return false;
}

export function isFilterCircular(targetFilterRules, currentfilterId) {
  for (var key in targetFilterRules) {
    if (
      targetFilterRules[key].ruleValue === currentfilterId &&
      targetFilterRules[key].operationId === "5"
    )
      return true;
  }
  return false;
}

export function findTagById(tagId, allTags) {
  return [_.find(allTags, ["id", tagId])];
}

export function shortenString(string, length) {
  if (!string) return string;
  var shortend = "";
  if (string.length >= length) {
    shortend = string.substr(0, length) + "...";
  } else {
    shortend = string;
  }

  return shortend;
}

export function isNull(value) {
  if (
    value == null ||
    typeof value == "undefined" ||
    value === undefined ||
    value === ""
  ) {
    return true;
  } else {
    return false;
  }
}

export function isZero(value) {
  if (value === "0" || value === 0 || value == null) {
    return true;
  } else {
    return false;
  }
}

export function resetAllScroll() {
  localStorage.setItem("posDomains", -300);
  localStorage.setItem("posCases", -300);
}

export function showMediaTags() {
  var toShow = JSON.parse(localStorage.getItem("media_info_config"))[
    "show_media_tags"
  ];
  return toShow;
}

export function showExternalGalleryUrl() {
  var toShow = JSON.parse(localStorage.getItem("media_info_config"))[
    "use_external_url"
  ];
  return toShow;
}

export function createExternalGalleryUrl(imageData) {
  var url = JSON.parse(localStorage.getItem("media_info_config"))[
    "external_url"
  ];

  if (!url || url.length === 0) return "";

  // check if needed data is available
  if (!imageData) return "";
  if (
    url.indexOf("{searchimage_filename}") !== -1 &&
    (!imageData.searchNumber || imageData.searchNumber.length === 0)
  )
    return "";
  if (
    url.indexOf("{searchimage_filename_no_extension}") !== -1 &&
    (!imageData.searchNumber || imageData.searchNumber.length === 0)
  )
    return "";

  if (
    url.indexOf("{searchimage_hash}") !== -1 &&
    (!imageData.searchimage_hash || imageData.searchimage_hash.length === 0)
  )
    return "";
  if (
    url.indexOf("{object_name}") !== -1 &&
    (!imageData.objectName || imageData.objectName.length === 0)
  )
    return "";

  url = url.replace("{searchimage_filename}", imageData.searchNumber);
  url = url.replace(
    "{searchimage_filename_no_extension}",
    imageData.searchNumber.split(".").slice(0, -1).join("."),
  );
  url = url.replace("{searchimage_hash}", imageData.searchimage_hash);
  url = url.replace("{object_name}", imageData.objectName);

  return url;
}

export function isImageProfessionalAccount() {
  return (
    [
      "307164e4-e823-41b8-b555-1811b55a1783",
      "5391878b-10e3-4626-b154-188606f2de80",
      "bd0c9c33-2658-43dc-8c2f-1b8de25bb0de",
      "494daff1-299e-48e0-94f7-1d389339c272",
      "da2ca510-7e81-44b5-8ef4-4fa5164bd320",
      "35e282d8-9167-43ff-aae4-678f9d6ea787",
      "57550f35-86dd-4e89-8edb-8705ebb932c5",
      "a05ff2cb-6954-4247-b5e7-8c30ac03bf1e",
      "26008010-0ec9-4d99-9444-94bbafb72d38",
      "2f8d97d9-e907-497d-88e3-95064d9e5c39",
      "68d56e49-8980-4883-b812-aae3bf50795c",
      "0b7b1456-d70f-4a50-82b3-b7512900127c",
      "6a5722ec-ffb3-41e9-a2b4-bab5901bc71e",
      "e298c05f-c651-4315-9612-cde7cbf23132",
      "b2890770-7d77-4276-869a-d7450b3a4a4c",
      "a62eec7c-47fa-4aeb-9b90-fbd306a7444f",
    ].indexOf(localStorage.getItem("CustomerID").toLocaleLowerCase()) !== -1
  );
}

export function showMediaNotes() {
  var toShow = JSON.parse(localStorage.getItem("media_info_config"))[
    "show_media_notes"
  ];
  return toShow;
}

export function atou(str) {
  return decodeURIComponent(escape(window.atob(str)));
}

export function countryCodeToFullName(countryCode) {
  var retval = "";
  if (!countryCode) return retval;

  if (operatorCountryConfig.default[countryCode.toUpperCase()])
    retval = operatorCountryConfig.default[countryCode.toUpperCase()].fullname;

  return retval;
}

export function isClaimFilter(filterid) {
  return filterid === "claim" || filterid === "CLAIM";
}

export function extractRouteFromCollectionPartner(caseInfo) {
  if (!caseInfo) return undefined;

  if (caseInfo.flpCustomerDefinition) {
    return "FLP - " + caseInfo.flpCustomerDefinition.split(":")[1];
  }

  if (caseInfo.collectionPartner) return caseInfo.collectionPartner;

  return undefined;
}

export function parseJwt(token) {
  try {
    return JSON.parse(atou(token.split(".")[1]));
  } catch (e) {
    return null;
  }
}


